import React from 'react'

const Footer = () => {
  return (
    <div>
     <div id="box7">
            <div class="box7">
                <span class="boldtext">Quick Links</span>
                <br/><br/>
                Sarkari Result <a href="/">LINK 1</a> <br/>
                Sarkari Result <a href="/">LINK 2</a> <br/>
                Sarkari Result <a href="/">LINK 3</a> <br/>
                Sarkari Result <a href="/">LINK 4</a> <br/>
                Sarkari Result <a href="/">LINK 5</a> <br/>
                Sarkari Result <a href="/">LINK 6</a> <br/>
                Sarkari Result <a href="/">LINK 7</a> <br/>
                Sarkari Result <a href="/">LINK 8</a> <br/>
                Sarkari Result <a href="/">LINK 9</a> <br/>
            </div>
            <div class="box7">
                <span class="boldtext">Apps</span>
                <br/><br/>
                Android App <br/>
                Apple IOS App <br/>
                Windows App
            </div>
            <div class="box7">
                <span class="boldtext">More</span>
                <br/><br/>
                BPSC <br/>
                Up-scholorship <br/>
                UPSC <br/>
                RPSC <br/>
                UPPCS <br/>
                Coast Guard
            </div>
            <div class="box7">
                <br/><br/><br/>
                text 1 <br/>
                text 2 <br/>
                text 3 <br/>
                text 4 <br/>
                text 5 <br/>
                text 6
            </div>
            <div class="box7">
                <br/><br/><br/>
                text 1 <br/>
                text 2 <br/>
                text 3 <br/>
                text 4 <br/>
                text 5
            </div>
        </div>
    </div>
  )
}

export default Footer
